import Container from 'components/container';
import React, { useMemo } from 'react';

export const FooterCopyRight: React.FC = () => {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <div className='border-t border-[#eeeeee] py-[26px]'>
      <Container>
        <p className='text-center text-base font-normal text-hl-dark'>&copy; Copyright {currentYear}</p>
      </Container>
    </div>
  );
};
